/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const getLocationType = (data) => {
    switch (data) {
        case '1': return 'Residence';
        case '2': return 'Business';
        case '3': return 'Building';
        case '4': return 'Funeral Home';
        case '5': return 'Hospital';
        case '6': return 'Apartment';
        case '7': return 'Rural Route';
        case '8': return 'School';
        case '9': return 'APO/FPO';
        case '10': return 'P.O. Box';
        case '11': return 'Church';
        default: return 'Residence';
    }
};

export default getLocationType;
